(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glaamorr-blog-pagination"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest('.glaamorr-blog-pages a');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(link.href);
}, true);
  } catch(e) { console.error(e); }
})();

})();
